import { LRUCache } from 'js-lru';

export default {
    // maxSize = maximum number of values to cache
    // calculateKey = function that calculates a key to find out if values have been cached for given input parameters
    // calculateValue = function to memoize
    create(maxSize, calculateKey, calculateValue) {
        const cache = new LRUCache(maxSize);

        return {
            // Get calculated value from the cache; if it's missing, calculate it and add it to the cache
            memoize(...args) {
                const key = calculateKey(...args);
                let entry = cache.get(key);
                if (typeof entry === 'undefined') {
                    entry = calculateValue(...args);
                    cache.put(key, entry);
                }
                return entry;
            },

            // Calculate value and add it to the cache regardless if it is already present
            add(...args) {
                cache.put(calculateKey(...args), calculateValue(...args));
            },

            // Return a value for the given arguments only if it is present in the cache; does affect LRU tracking
            get(...args) {
                return cache.get(calculateKey(...args));
            },

            // Check if the cache contains a value for the given arguments; does not affect LRU tracking
            has(...args) {
                const entry = cache.find(calculateKey(...args));
                return typeof entry !== 'undefined';
            },

            // Reset the cache and remove all elements
            clear() {
                cache.removeAll();
            }
        };
    }
};
